import { FC } from 'react';
import { Installation } from 'data/api';
import { DetailPanel } from 'src/components/DetailPanel';

type CustomerDetailPanelProps = {
  customerName: string;
  groupRef: string;
  customerInstallations: Installation[];
};

/**
 * CustomerDetailPanel displays customer information and installations
 * Shows customer details with expandable view of customer data
 */
export const CustomerDetailPanel: FC<CustomerDetailPanelProps> = ({
  customerName,
  groupRef,
  customerInstallations,
}) => {
  const badges = [
    { label: 'Customer Name', value: customerName },
    { label: 'Total Installations', value: String(customerInstallations.length) },
  ];

  const description =
    `View all installations for ${customerName}. Click any installation row below to see ` +
    `detailed information, operation logs, and configuration settings.`;

  // Create a simplified customer object for the detail view
  const customerData = {
    groupRef,
    groupName: customerName,
    totalInstallations: customerInstallations.length,
    installations: customerInstallations.map((installation) => ({
      id: installation.id,
      integrationId: installation.integrationId,
      healthStatus: installation.healthStatus,
      createTime: installation.createTime,
    })),
  };

  return (
    <DetailPanel
      title="Customer Details"
      idLabel="Customer Reference"
      idValue={groupRef}
      description={description}
      badges={badges}
      expandButtonText="View customer data"
      detailTitle="Customer Information"
      fullObject={customerData}
    />
  );
};
